import { TextField } from '@material-ui/core';
import React from 'react';

import { IWithStylesProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';

export interface ITextFieldWithDefaultValueProps extends IWithStylesProps {
  isSuperUser: boolean;
  bidder: string;
  label: string;
  name: string;
  description: string;
  defaultValue: string;
  cb: (name: string, value: any) => void;
  disabled?: boolean;
  canEdit?: boolean;
}

export const TextFieldWithDefaultValue = decorate(
  {
    styles: (theme: any) => ({
      section: {
        display: 'block',
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
        maxWidth: 400,
      },
      sectionHidden: {
        display: 'none',
      },
      input: {
        fontSize: 14,
        maxWidth: 400,
      },
    }),
  },
  class extends React.Component<ITextFieldWithDefaultValueProps> {
    handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      if (this.props.canEdit) {
        this.props.cb(this.props.name, target.value);
      }
    };

    render() {
      const { classes } = this.props;
      return (
        <div className={this.props.isSuperUser ? classes.section : classes.sectionHidden}>
          <TextField
            name={this.props.name}
            fullWidth
            multiline
            disabled={!!this.props.disabled || !this.props.canEdit}
            onChange={this.handleChange}
            value={this.props.defaultValue || ''}
            helperText={this.props.description + ' *'}
            InputProps={{
              classes: {
                input: this.props.classes.input,
              },
            }}
          />
        </div>
      );
    }
  },
);
